/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Unit of measure enumeration for day. Supported values are:
 * - d (day of the month)
 * - mth (month)
 * - y (year)
 *
 */
export var DateUomEnum;
(function (DateUomEnum) {
    DateUomEnum["D"] = "d";
    DateUomEnum["MTH"] = "mth";
    DateUomEnum["Y"] = "y";
})(DateUomEnum || (DateUomEnum = {}));
